module.exports = "/fonts/quark-light.woff?5be589bd8dbf8eb2694d6a223cc1f248";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/fonts/Quark/quark-light.woff
// module id = /0Sc
// module chunks = 0